/* eslint-disable quotes */
import i18n from '.';

export const libraryPageTitle = (): string =>
  i18n._translate('Library', {
    context: 'Title for the overall page that contains many workouts.',
  });

export const myListTitle = (): string =>
  i18n._translate('My List', {
    context:
      'Title for a section of continued series, favorited, and user-created workouts.',
  });

export const myChallengesTitle = (): string =>
  i18n._translate('Challenges', {
    context:
      'Title for a section of challenges. A single challenge is a set of workouts, available for a limited period of time, often with a prize for completing them all before the end of the challenge.',
  });

export const myCurrentChallengesTitle = (): string =>
  i18n._translate('Current Challenges', {
    context: 'Title for a section of current challenges.',
  });

export const continueSeriesAndChallengesTitle = (): string =>
  i18n._translate('Continue Series and Challenges', {
    context: 'Title for a section of continued series and challenges.',
  });

export const myWorkoutsTitle = (): string =>
  i18n._translate('My Created Workouts', {
    context: 'Title for a section of user-created workouts.',
  });

export const myFavoritesTitle = (): string =>
  i18n._translate('My Favorites', {
    context:
      "Title for a section of the user's favorite workouts and series. A series is a set of related workouts that the user completes over several weeks.",
  });

export const pastChallengesTitle = (): string =>
  i18n._translate('Past Challenges', {
    context:
      "Title for a section of the user's past challenge series. A series is a set of related workouts that the user completes over several weeks.",
  });

export const trophyCaseTitle = (): string =>
  i18n._translate('Trophy Case', {
    context:
      'Title for a page which shows digital trophy images for the challenges, milestones, and live events the user has completed or has started.',
  });

export const liveEventsTabTitle = (): string =>
  i18n._translate('Live Events', {
    context:
      'Text on a button which, when pressed, shows digital trophy images for the live events the user has completed.',
  });

export const milestonesTabTitle = (): string =>
  i18n._translate('Milestones', {
    context:
      'Text on a button which, when pressed, shows digital trophy images for the milestones the user has accomplished.',
  });

export const workoutsTitle = (): string =>
  i18n._translate('Workouts', {
    context: 'Title for a section of workouts.',
  });

export const seriesTitle = (): string =>
  i18n._translate('Series', {
    context:
      'Title for a section of fitness series. A series is a set of related workouts that the user completes over several weeks.',
  });

export const trainerTitle = (): string =>
  i18n._translate('Trainer', {
    context: 'A personal fitness trainer.',
  });

export const trainersTitle = (): string =>
  i18n._translate('Trainers', {
    context: 'Title for a section of personal fitness trainers.',
  });

export const categoriesTitle = (): string =>
  i18n._translate('Categories', {
    context: 'Title for a group of categories of workouts.',
  });

export const subcategoriesTitle = (): string =>
  i18n._translate('Subcategories', {
    context: 'Title for a group of subcategories of workouts.',
  });

export const freeCategoriesTitle = (): string =>
  i18n._translate('Free Categories', {
    context:
      'Title for a group of categories of workouts that are free to use.',
  });

export const categorySeriesTitle = (category: string): string =>
  i18n._translate('%{category} Series', {
    context:
      'The title of a page which contains multiple sets of workouts (referred to as Series) filtered by the specific type of workout. E.g., "Running Series"',
    category,
  });

export const includedWorkoutsTitle = (): string =>
  i18n._translate('Included Workouts', {
    context: 'Title for a section of workouts that are included for free.',
  });

export const viewDetailsButtonText = (): string =>
  i18n._translate('View Details', {
    context:
      'Button text. Tapping the button pops up a modal with more details about the workout or series. A series is a set of related workouts that the user completes over several weeks.',
  });

export const viewSeriesButtonText = (): string =>
  i18n._translate('View Series', {
    context:
      'Link text. Tapping the button pops up a modal with more details about the series. A series is a set of related workouts that the user completes over several weeks.',
  });

export const viewWorkoutButtonText = (): string =>
  i18n._translate('View Workout', {
    context:
      'Link text. Tapping the button pops up a modal with more details about the workout.',
  });

export const numberOfWorkoutsLabel = (count: number): string =>
  i18n._translate('%{count} Workout', {
    plural: '%{count} Workouts',
    context:
      'Label to tell the user how many workouts are in a series. A series is a set of related workouts that the user completes over several weeks.',
    count,
  });

export const numberOfWeeksLabel = (count: number): string =>
  i18n._translate('%{count} Week', {
    plural: '%{count} Weeks',
    context:
      'Label to tell the user how many weeks are in a series. A series is a set of related workouts that the user completes over several weeks.',
    count,
  });

export const readMoreButtonText = (): string =>
  i18n._translate('Read More', {
    context: 'Tapping this button expands a text area.',
  });

export const readBioText = (): string =>
  i18n._translate('Read Bio', {
    context:
      'Tapping this button expands a text area to read more. Bio is short for biography. This text contains more information about a personal fitness trainer.',
  });

export const closeBioText = (): string =>
  i18n._translate('Close Bio', {
    context:
      'Tapping this button closes a text area. Bio is short for biography. This text contains more information about a personal fitness trainer.',
  });

export const searchText = (): string =>
  i18n._translate('Search', {
    context:
      'Title for the search page where workouts can be searched for with text entry and/or filtered down based on search criteria.',
  });

export const filtersText = (): string =>
  i18n._translate('Filters', {
    context:
      'Label above an area full of controls that allow you filter down your search results.',
  });

export const applyButtonText = (): string =>
  i18n._translate('Show Results', {
    context:
      'Tapping this button applies the currently selected search criteria',
  });

export const clearButtonText = (): string =>
  i18n._translate('Clear All', {
    context: 'Tapping this button clears all search criteria',
  });

export const clearFilterButtonText = (): string =>
  i18n._translate('Clear', {
    context:
      'Tapping this button clears all selected filters within a single filter dropdown',
  });

export const closeFilterButtonText = (): string =>
  i18n._translate('Close', {
    context:
      'Tapping this button closes an open filter dropdown, hiding it from view.',
  });

export const searchResultsText = (): string =>
  i18n._translate('Search results', {
    context:
      'A heading at the top of where search results are shown. The results are workouts.',
  });

export const noSearchResultsText = (): string =>
  i18n._translate('Sorry! Your search has returned no results.', {
    context:
      'This text appears where the search results are normally shown, if the search returns no results.',
  });

export const searchResultsWithFiltersCount = count =>
  i18n._translate('%{count} filter applied', {
    plural: '%{count} filters applied',
    context:
      'A heading at the top of where there numbers of filters selected are shown.',
    count,
  });

const zeroCheck = (items: number): string | number => {
  if (items === 0) {
    return 0;
  }
  return items ? items : '...';
};

export const searchResultsWithCountText = (
  totalNumberOfResults: number,
  query: string,
): string =>
  query
    ? i18n._translate('%{totalNumberOfResults} results for "%{searchText}"', {
        context:
          'A heading at the top of where search results are shown when the user enters search text. The results are workouts, and the total number of results is shown. The search text will be entered by the user.',
        totalNumberOfResults: zeroCheck(totalNumberOfResults),
        searchText: query,
      })
    : i18n._translate('%{totalNumberOfResults} results', {
        context:
          'A heading at the top of where search results are shown. The results are workouts, and the total number of results is shown.',
        totalNumberOfResults: zeroCheck(totalNumberOfResults),
      });

export const searchAllTypes = (): string =>
  i18n._translate('All', {
    context:
      'Text on a button on the search page, which when selected shows all available workouts and series that match filter criteria',
    searchAllTypes,
  });

export const newestText = (): string =>
  i18n._translate('Newest', {
    context: 'Choosing this option will sort workouts by how new they are.',
  });

export const topRatedText = (): string =>
  i18n._translate('Top Rated', {
    context:
      'Choosing this option will sort workouts by how highly users have rated them (out of 5 stars.)',
  });

export const trendingText = (): string =>
  i18n._translate('Trending', {
    context:
      'Choosing this option will sort workouts by how many users have completed them in the last week. More popular workouts will show up first.',
  });

export const relevanceText = (): string =>
  i18n._translate('Relevance', {
    context:
      'Choosing this option will sort workouts by how close of a match the workout is to the user supplied search query text.',
  });

export const easiestText = (): string =>
  i18n._translate('Easiest', {
    context:
      'Choosing this option will sort workouts by how difficult they are.',
  });

export const hardestText = (): string =>
  i18n._translate('Hardest', {
    context:
      'Choosing this option will sort workouts by how difficult they are.',
  });

export const shortestText = (): string =>
  i18n._translate('Shortest', {
    context:
      'Choosing this option will sort workouts by how much time they take to complete.',
  });

export const longestText = (): string =>
  i18n._translate('Longest', {
    context:
      'Choosing this option will sort workouts by how much time they take to complete.',
  });

export const getUnlimitedAccessText = (): string =>
  i18n._translate('Get unlimited access to the expansive workout Library!', {
    context:
      'A message that appears in the free version of the fitness library, encouraging users to upgrade.',
  });

export const upgradeButtonText = (): string =>
  i18n._translate('Upgrade membership', {
    context:
      'Tapping this button takes you to a screen where you can sign up for an iFIT membership.',
  });

export const loadingText = (): string =>
  i18n._translate('Loading...', {
    context:
      'A temporary message to let the user know that their content is loading.',
  });

export const challengesLoadingText = (): string =>
  i18n._translate('See all current Challenges', {
    context: 'Button text to load the next set of workouts on click',
  });

export const whoopsMessage = (): string =>
  i18n._translate('Whoops! An error occurred.', {
    context:
      'A friendly and generic error message for when the app encounters an unknown error.',
  });

export const freeSignUpButtonText = (): string =>
  i18n._translate('Begin Today', {
    context:
      'Tapping this button takes you to a screen where you can sign up for an iFIT membership.',
  });

export const freeSignUpTitle = (): string =>
  i18n._translate('Kick off your fitness journey today!', {
    context: 'Title for a featured section header for free users',
  });

export const freeSignUpSubTitle = (): string =>
  i18n._translate('Try out unlimited, on-demand workouts with top trainers.', {
    context: 'Subtitle for a featured section header for free users ',
  });

export const expiredSignUpTitle = (): string =>
  i18n._translate('Ready for your next challenge?', {
    context:
      'Title for a featured section header for free users with expired accounts',
  });

export const expiredSignUpSubTitle = (): string =>
  i18n._translate(
    'Upgrade your membership to keep moving toward a better you.',
    {
      context:
        'Subtitle for a featured section header for free users with expired accounts',
    },
  );

export const pausedSignUpSubTitle = (): string =>
  i18n._translate(
    'Your membership is currently paused. Renew your subscription to keep moving toward a better you!',
    {
      context:
        'Subtitle for a featured section header for free users with paused accounts',
    },
  );

// trophy case
export const noChallengesAchievementData = (): string =>
  i18n._translate('You have not completed any Challenges.', {
    context:
      'This text will be shown in the Trophy Case when the user has not completed or started any challenges in the recent months.',
  });

export const upgradeFreeChallengesAchievementCaption = (): string =>
  i18n._translate('Upgrade for access to challenges.', {
    context:
      'This text is shown if a user who is not paying a subscription tries to view their challenge achievements.',
  });

export const discoverChallenges = (): string =>
  i18n._translate('Discover Challenges', {
    context:
      'This link will take the user to the page where they can start or continue a Challenge series of workouts.',
  });

export const noLiveEventsAchievementData = (): string =>
  i18n._translate('You have not completed any Live Events.', {
    context:
      'This text will be shown in the Trophy Case when the user has not completed or started any live events in the recent months.',
  });

export const upgradeFreeEventsAchievementCaption = (): string =>
  i18n._translate('Upgrade for access to live events.', {
    context:
      'This text is shown if a user who is not paying a subscription tries to view their live event achievements.',
  });

export const upgradeFreeMilestonesAchievementCaption = (): string =>
  i18n._translate('Upgrade for access to milestones.', {
    context:
      'This text is shown if a user who is not paying a subscription tries to view their achieved milestones.',
  });

// milestones

export const milestonesLineDivider = (): string =>
  i18n._translate('Next up', {
    context:
      'Text on a line that divides the last completed Milestone from the next one to complete',
  });

export const milestonesTitle = (): string =>
  i18n._translate('%{year} Milestones', {
    context: 'Header for the Milestones row',
    year: new Date().getFullYear(),
  });

export const milestonesYear = (year?: number): string =>
  i18n._translate('Milestones %{year}', {
    context:
      'Title for describing the Milestones accomplished by a user within one year',
    year: year ? year : new Date().getFullYear(),
  });

export const currentYearMilestoneInfoPanel = (year?: number): string =>
  i18n._translate(
    'Current year milestones are the total number of completed iFIT workouts since Jan. 1, %{year}. This excludes workouts imported from third-party apps.',
    {
      context:
        'Description of current year milestones that displays when a user clicks the info icon',
      year: year ? year : new Date().getFullYear() - 1,
    },
  );

export const pastYearMilestoneInfoPanel = (year: number): string =>
  i18n._translate(
    'Past year milestones are the total number of completed iFIT workouts in %{year}. This excludes manual workouts and workouts imported from third-party apps.',
    {
      context:
        'Description of past year milestones that displays when a user clicks the info icon',
      year: year,
    },
  );

export const pastYearMilestoneInfoPanelPost2025 = (year: number): string =>
  i18n._translate(
    'Past year milestones are the total number of completed iFIT workouts in %{year}. This excludes workouts imported from third-party apps.',
    {
      context:
        'Description of past year milestones that displays when a user clicks the info icon.',
      year: year,
    },
  );

export const browseWorkouts = (): string =>
  i18n._translate('Browse Workouts', {
    context:
      'This link will take the user to the iFIT library where they can browse workouts',
  });

export const challengesInfoPanel = (): string =>
  i18n._translate('These results include recently completed Challenges.', {
    context: 'Description of recently completed Challenges',
  });

export const liveEventsInfoPanel = (): string =>
  i18n._translate('These results include recently completed Live Events.', {
    context: 'Description of recently completed Live Events',
  });

export const daysRemaining = (): string =>
  i18n._translate('Days Remaining', {
    context: 'Text describing days remaining in a year',
  });

export const completedByEndOfYear = (): string =>
  i18n._translate('Completed by end of year', {
    context: 'Text describing milestones completed by the end of a year',
  });

export const milestonesWorkoutsCompleted = (): string =>
  i18n._translate('Workouts completed', {
    context:
      'Title above the workouts completed count for the Milestones bar and Milestones Row',
  });

export const milestonesNextMilestone = (): string =>
  i18n._translate('Next milestone', {
    context:
      'Title above the number of workouts needed to reach the next milestone',
  });

export const hasNoCompletedMilestonesInCurrentYear = (year?: number): string =>
  i18n._translate('You have not completed any milestones yet in %{year}', {
    context:
      'Message telling user that they have not completed any milestones for the year',
    year: year ? year : new Date().getFullYear(),
  });

export const hasNoCompletedMilestonesInPastYears = (year?: number): string =>
  i18n._translate('You did not complete any milestones in %{year}', {
    context:
      'Message telling user that they have not completed any milestones for the year',
    year: year ? year : new Date().getFullYear(),
  });

export const milestonesInfoText = (): string =>
  i18n._translate(
    'Any workouts from the iFIT Library that you complete in %{year} counts toward your Milestones. Whenever you reach a milestone, you’ll receive an email!',
    {
      context:
        'Info text in the Milestones row describing what workouts are counted towards the count and how users can redeem their gifts. We want to emphasize to users that manual workouts do NOT count toward Milestones.',
      year: new Date().getFullYear(),
    },
  );

export const milestoneTextCompleted1 = (): string =>
  i18n._translate("First workout done! Let's go!", {
    context: 'Text to display in milestone card for workout completed count 1',
  });

export const milestoneTextCompleted5 = (): string =>
  i18n._translate("You're doing amazing!", {
    context: 'Text to display in milestone card for workout completed count 5',
  });

export const milestoneTextCompleted25 = (): string =>
  i18n._translate('Keep up the great work!', {
    context: 'Text to display in milestone card for workout completed count 25',
  });

export const milestoneTextCompleted50 = (): string =>
  i18n._translate('Halfway to your first reward!', {
    context: 'Text to display in milestone card for workout completed count 50',
  });

export const milestoneTextCompleted75 = (): string =>
  i18n._translate('Consistency is key!', {
    context: 'Text to display in milestone card for workout completed count 75',
  });

export const milestoneTextCompleted100 = (): string =>
  i18n._translate('You unlocked a free iFIT t-shirt!', {
    context:
      'Text to display in milestone card for workout completed count 100',
  });

export const milestoneTextCompleted150 = (): string =>
  i18n._translate('You are #fitnessgoals!', {
    context:
      'Text to display in milestone card for workout completed count 150',
  });

export const milestoneTextCompleted200 = (): string =>
  i18n._translate('You unlocked a free month of iFIT!', {
    context:
      'Text to display in milestone card for workout completed count 200',
  });

export const milestoneTextCompleted250 = (): string =>
  i18n._translate('Halfway to 500 workouts! You’re awesome!', {
    context:
      'Text to display in milestone card for workout completed count 250',
  });

export const milestoneTextCompleted300 = (): string =>
  i18n._translate('You unlocked a free iFIT flag!', {
    context:
      'Text to display in milestone card for workout completed count 300',
  });

export const milestoneTextCompleted350 = (): string =>
  i18n._translate('Progress over perfection! You got this!', {
    context:
      'Text to display in milestone card for workout completed count 350',
  });

export const milestoneTextCompleted400 = (): string =>
  i18n._translate('You unlocked a $100 iFIT Shop gift card!', {
    context:
      'Text to display in milestone card for workout completed count 400',
  });

export const milestoneTextCompleted450 = (): string =>
  i18n._translate('Your commitment is epic!', {
    context:
      'Text to display in milestone card for workout completed count 450',
  });

export const milestoneTextCompleted500 = (): string =>
  i18n._translate(
    'You unlocked a free sweatshirt and iFIT Studio tour drawing entry!',
    {
      context:
        'Text to display in milestone card for workout completed count 500',
    },
  );

export const milestoneText = (count: number): string =>
  i18n._translate('Complete %{count} workout.', {
    plural: 'Complete %{count} workouts.',
    context:
      'Number of workouts that need to be achieved to unlock the milestone.',
    count,
  });

export const okText = (): string =>
  i18n._translate('OK', {
    context: 'text for OK buttons',
  });
export const upgradeModalTitle = (): string =>
  i18n._translate('iFIT Subscription', {
    context: 'Title for the upgrade membership modal',
  });
export const upgradeModalContent = (): string =>
  i18n._translate('Please visit iFIT.com to activate your iFIT subscription.', {
    context: 'Body text for upgrade membership modal',
  });
